import { render, staticRenderFns } from "./ResultRoad.vue?vue&type=template&id=4bc85d36&"
import script from "./ResultRoad.vue?vue&type=script&lang=js&"
export * from "./ResultRoad.vue?vue&type=script&lang=js&"
import style0 from "./ResultRoad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports